/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useRef, useEffect } from "react";
// @ts-expect-error TS(6133): 'api' is declared but its value is never read.
import { api } from "jiffy-api";
import { isMobile, redirectTo } from "common/utils/browser";
import { writePersistentCookie } from "common/utils/cookie";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { cn } from "tailwind-variants";
import "./GangSheetInfoModal.scss";

function GangSheetInfoModal({ currentStore = null, ...restProps }) {
  const [isMobileState] = useState(isMobile());
  const closedRef = useRef(false);
  const modalRef = useRef(null);

  function gangSheetDesktopImage() {
    return remoteImageStaticUrl("gen/gangsheet-modal-image.png");
  }

  function gangSheetMobileSmallImage() {
    return remoteImageStaticUrl("gen/gang-sheet-info-image-mobile-small2.png");
  }

  function gangSheetMobileBigImage() {
    return remoteImageStaticUrl("gen/gang-sheet-info-image-mobile-big.png");
  }

  function closeModal() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    $(modalRef.current).modal("hide");
    closedRef.current = true;
    writePersistentCookie("gang-sheet-info-modal-shown", true);
  }

  function showModal() {
    // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
    const $$modal = $(modalRef.current);
    $$modal.modal("show").on("hidden.bs.modal", () => {
      $$modal.off("hidden.bs.modal");
      if (!closedRef.current) {
        closeModal();
      }
    });
  }

  function jiffyTransferLink() {
    const baseLink = "/jiffytransfers";
    return currentStore === "ca" ? `/ca${baseLink}` : baseLink;
  }

  function redirectToGangSheetUrl() {
    const baseLink = "/jiffytransfers-DTFGANG001.html";
    const redirectPath = currentStore === "ca" ? `/ca${baseLink}` : baseLink;
    redirectTo(redirectPath);
    closeModal();
  }

  function redirectToDtfUrl() {
    const baseLink = "/jiffytransfers-DTF001.html";
    const redirectPath = currentStore === "ca" ? `/ca${baseLink}` : baseLink;
    redirectTo(redirectPath);
    closeModal();
  }

  useEffect(() => {
    showModal();
    return () => {
      // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
      const $$modal = $(modalRef.current);
      $$modal.modal("hide");
      $$modal.off("hidden.bs.modal");
    };
  }, []);

  const isNewDtfCustomer = false;

  return (
    <div
      {...restProps}
      className="modal gang-sheet-info-modal scope-ae85cf8b"
      ref={modalRef}
      role="dialog"
      data-testid="modal"
    >
      <div className="gang-sheet-info-modal__modal-box modal-dialog scope-ae85cf8b">
        <div className="gang-sheet-info-modal__modal-body scope-ae85cf8b">
          <button
            className="gang-sheet-info-modal__modal-button-close scope-ae85cf8b"
            type="button"
            onClick={closeModal}
            data-testid="gang-sheet-info-modal-modal-button-close"
          >
            <UseSvg className="scope-ae85cf8b" icon="modal-close-big" data-testid="use-svg" />
          </button>
          <div className="gang-sheet-info-modal__image-box scope-ae85cf8b">
            <div className="gang-sheet-info-modal__image-bg scope-ae85cf8b" />
            {!isMobileState ? (
              <img
                className="gang-sheet-info-modal__image scope-ae85cf8b"
                src={gangSheetDesktopImage()}
                alt="Sample image 1"
              />
            ) : null}
            {isMobileState && isNewDtfCustomer ? (
              <img
                className="gang-sheet-info-modal__image scope-ae85cf8b"
                src={gangSheetMobileSmallImage()}
                alt="Sample image 1"
              />
            ) : null}
            {isMobileState && !isNewDtfCustomer ? (
              <img
                className="gang-sheet-info-modal__image scope-ae85cf8b"
                src={gangSheetMobileBigImage()}
                alt="Sample image 1"
              />
            ) : null}
          </div>
          <div
            className={cn(
              "gang-sheet-info-modal__info scope-ae85cf8b",
              isMobileState && "gang-sheet-info-modal__info--wide-margin"
            )}
          >
            <UseSvg
              className="gang-sheet-info-modal__logo scope-ae85cf8b"
              icon="jiffy-transfers-inline"
              data-testid="gang-sheet-info-modal-logo"
            />

            <div className="gang-sheet-info-modal__title gang-sheet-info-modal__title--wide-margin scope-ae85cf8b">
              <p className="gang-sheet-info-modal__title-text scope-ae85cf8b">
                JiffyTransfers supports
              </p>
              <p className="gang-sheet-info-modal__title-text scope-ae85cf8b">
                Gang Sheet printing!
              </p>
            </div>
            <button
              className="gang-sheet-info-modal__button gang-sheet-info-modal__button--white scope-ae85cf8b"
              type="button"
              onClick={redirectToGangSheetUrl}
              data-testid="gang-sheet-info-modal-button"
            >
              {" "}
              Upload a Gang Sheet{" "}
            </button>
            <span className="gang-sheet-info-modal__small-text scope-ae85cf8b">or</span>
            <button
              className="gang-sheet-info-modal__button gang-sheet-info-modal__button--pink scope-ae85cf8b"
              type="button"
              onClick={redirectToDtfUrl}
              data-testid="gang-sheet-info-modal-button-1"
            >
              {" "}
              Upload single images{" "}
            </button>
            <div className="gang-sheet-info-modal__info-text gang-sheet-info-modal__info-text--wide-margin scope-ae85cf8b">
              {" "}
              What is{" "}
              <a
                className="gang-sheet-info-modal__info-link scope-ae85cf8b"
                href={jiffyTransferLink()}
                onClick={closeModal}
                data-testid="gang-sheet-info-modal-info-link"
              >
                {" "}
                Jiffy Transfers?{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GangSheetInfoModal;
